module.exports = __webpack_public_path__ + "img/icon_system_implementation_data.38604f35.svg";